import info from './images/info.svg'

export default function InfoIcon(props) {
  return (
    <img src={info} alt="info" onClick={props.onClick} />
  )
}
